import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  PostInstructorsRequestsBatchRequest,
  PostInstructorsRequestsBatchResponse,
} from './postInstructorsRequestsBatch.types';

/**
 * Submit batch approval requests for multiple unapproved instructors at once.
 * Endpoint: POST /instructors/requests/batch
 *
 * `customerId` is sent as a request header.
 * Returns a summary of total, successful, and failed requests.
 */
export async function postInstructorsRequestsBatch(
  customerId: string,
  data: PostInstructorsRequestsBatchRequest
): Promise<PostInstructorsRequestsBatchResponse> {
  const response =
    await axiosInstance.post<PostInstructorsRequestsBatchResponse>(
      '/instructors/requests/batch',
      data,
      { headers: { 'X-Customer-Id': customerId } }
    );

  return response.data;
}
